/**
 * Maps frontend metric UI keys to the comparison API's supported metric keys.
 * The /admin/metrics/comparison endpoint only supports a fixed set of metric
 * keys; many UI metric ids are aliases of those. Shared between the Measure
 * Comparison dashboard and the inline metric breakdown panels.
 */
const COMPARISON_KEY_MAP: Record<string, string> = {
  hours_of_sleep: "sleep_duration",
  hours_of_sleep_needed: "sleep_duration",
  nap_duration: "sleep_duration",
  sleep_performance: "sleep_score",
  sleep: "sleep_score",
  sleep_efficiency: "sleep_score",
  sleep_consistency: "sleep_score",
  sleep_stress: "overall_stress",
  average_hrv: "hrv",
  recovery: "recovery_score",
  heart_rate: "resting_heart_rate",
  avg_heart_rate: "resting_heart_rate",
  max_heart_rate: "resting_heart_rate",
  stress_score: "overall_stress",
  stress_recovery_balance: "overall_stress",
  day_strain: "strain",
};

/** The set of metric keys the comparison API natively supports. */
export const COMPARISON_SUPPORTED = new Set([
  "sleep_score",
  "overall_stress",
  "recovery_score",
  "hrv",
  "strain",
  "sleep_duration",
  "resting_heart_rate",
  "respiratory_rate",
]);

/** Returns the comparison API key for a UI metric key, or null if not mappable. */
export const toComparisonKey = (uiKey: string): string | null => {
  if (COMPARISON_SUPPORTED.has(uiKey)) return uiKey;
  const mapped = COMPARISON_KEY_MAP[uiKey];
  return mapped && COMPARISON_SUPPORTED.has(mapped) ? mapped : null;
};
